import { useRouter } from 'nextjs-toploader/app'

import { Button } from '@/components/ui/tailwind/Button'
import { useSiteSettings } from '@/hooks/useSiteSettings'
import { useTranslations } from '@/hooks/useTranslations'

export const ContactButton = () => {
  const { translate, language } = useTranslations()
  const { getLinkByName } = useSiteSettings()
  const { push } = useRouter()
  const link = getLinkByName('product.contact')

  const handleClick = () => {
    push(link?.url ?? '/page/kontakt/produkt')
  }

  return (
    <Button onClick={handleClick} data-testid="product-contactButton" className="whitespace-nowrap">
      {link?.externalName?.[language] ?? translate('sidebar.navigation.customer_service')}
    </Button>
  )
}
